import * as React from "react"
import { SvgAlertTriangleSolid } from "@digits-shared/components/SVGIcons/solid/AlertTriangleSolid.svg"
import { SvgCheckCircleSolid } from "@digits-shared/components/SVGIcons/solid/CheckCircleSolid.svg"
import { useChromeAlertContext } from "src/frontend/components/Shared/Alerts/ChromeAlertsContext"

/*
 * In order for alerts to render, there must be an AlertsList mounted in the tree.
 * See components/Shared/ChromeAlerts.tsx
 */
export function useChromeAlerts() {
  const { addAlert } = useChromeAlertContext()

  const alertError = React.useCallback(
    (message: string, options?: { description?: string; persist?: boolean }) => {
      addAlert({
        id: "chrome-alert-error",
        message,
        description: options?.description,
        SVGComponent: SvgAlertTriangleSolid,
        autoDismiss: !options?.persist,
      })
    },
    [addAlert]
  )

  const alertSuccess = React.useCallback(
    (message: string, options?: { iconOverride: React.ReactNode }) => {
      addAlert({
        id: "chrome-alert-success",
        message,
        iconOverride: options?.iconOverride,
        SVGComponent: SvgCheckCircleSolid,
        autoDismiss: true,
      })
    },
    [addAlert]
  )

  return React.useMemo(() => ({ alertError, alertSuccess }), [alertError, alertSuccess])
}
